import { render, staticRenderFns } from "./photographDetailInfo.vue?vue&type=template&id=48b9905a&scoped=true&"
import script from "./photographDetailInfo.vue?vue&type=script&lang=js&"
export * from "./photographDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./photographDetailInfo.vue?vue&type=style&index=0&id=48b9905a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9905a",
  null
  
)

export default component.exports